import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfigurationsComponent } from './configurations.component';
import { SharedModule } from '../shared/shared.module';
import { FormVersionComponent } from './version/form-version/form-version.component';
import { VersionComponent } from './version/version.component';
import { LibraryComponent } from './library/library.component';
import { FormBookComponent } from './library/form-book/form-book.component';

@NgModule({
    declarations: [
        ConfigurationsComponent, 
        FormVersionComponent, 
        VersionComponent, LibraryComponent, FormBookComponent
    ],
    imports: [CommonModule, SharedModule],
})
export class ConfigurationsModule {}
